class VariantQtyAdd {
  constructor() {
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    document.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const button = event.target.closest('.variant-qty-add');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    const variantId = button.dataset.variantId;
    if (!variantId) return;
    const quantity = parseInt(button.dataset.quantity || '1', 10) || 1;

    button.classList.add('is-loading');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);

    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }

    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'variant-qty-add',
            productVariantId: variantId,
            errors: response.errors || response.description,
            message: response.message,
          });
          return;
        }

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'variant-qty-add',
          productVariantId: variantId,
          cartData: response,
        });

        this.cart.renderContents(response);
        if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        button.classList.remove('is-loading');
      });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!window.VariantQtyAddInstance) {
    window.VariantQtyAddInstance = new VariantQtyAdd();
  }
});
